export default __webpack_public_path__ + "static/kyrylo-1-f77675466dff70b833367bc7460f9591.png";